(() => {
  const root = document.documentElement;
  const live = () => document.getElementById('live-region');
  const announce = (text) => {
    const region = live();
    if (!region || !text) return;
    region.textContent = '';
    window.requestAnimationFrame(() => {
      region.textContent = text;
    });
  };
  const routes = {
    cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js',
    cart: '/cart.js'
  };

  document.querySelectorAll('[data-autofocus]').forEach((el, i) => {
    if (i === 0) el.focus();
  });

  const submenus = () => Array.from(document.querySelectorAll('[data-submenu]'));
  document.addEventListener('click', (event) => {
    submenus().forEach((d) => {
      if (d.open && !d.contains(event.target)) d.open = false;
    });
  });
  submenus().forEach((d) => {
    d.addEventListener('toggle', () => {
      if (d.open) submenus().forEach((o) => { if (o !== d) o.open = false; });
    });
    d.addEventListener('focusout', (event) => {
      if (d.open && event.relatedTarget && !d.contains(event.relatedTarget)) d.open = false;
    });
  });

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mobileMenu) {
    const summary = mobileMenu.querySelector('summary');
    summary.setAttribute('aria-expanded', String(mobileMenu.open));
    mobileMenu.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(mobileMenu.open));
      root.classList.toggle('is-locked', mobileMenu.open);
      document.querySelectorAll('main, .shopify-section-group-footer-group').forEach((el) => {
        el.inert = mobileMenu.open;
      });
    });
    // Infra code check CR-01: crossing to 1024 and up (an iPad rotated) with the menu open closes it, which runs the
    // toggle handler and releases inert; the desktop header has no menu to close it from.
    const desktop = window.matchMedia('(min-width: 1024px)');
    const onWidth = () => {
      if (desktop.matches && mobileMenu.open) mobileMenu.open = false;
    };
    if (desktop.addEventListener) desktop.addEventListener('change', onWidth);
    else if (desktop.addListener) desktop.addListener(onWidth);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openSub = submenus().find((d) => d.open);
    if (openSub) {
      openSub.open = false;
      openSub.querySelector('summary').focus();
      return;
    }
    if (mobileMenu && mobileMenu.open) {
      mobileMenu.open = false;
      mobileMenu.querySelector('summary').focus();
      return;
    }
    if (searchPanel && !searchPanel.hidden) closeSearch();
  });

  const searchPanel = document.querySelector('[data-search-panel]');
  const searchOpen = document.querySelector('[data-search-open]');
  const psInput = document.querySelector('[data-ps-input]');
  const psResults = document.querySelector('[data-ps-results]');
  let psController = null;
  let psPending = 0;
  let psActive = -1;

  const closeSearch = () => {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    if (searchOpen) {
      searchOpen.setAttribute('aria-expanded', 'false');
      searchOpen.focus();
    }
  };
  if (searchPanel && searchOpen) {
    searchOpen.addEventListener('click', (event) => {
      event.preventDefault();
      if (!searchPanel.hidden) {
        closeSearch();
        return;
      }
      if (mobileMenu && mobileMenu.open) mobileMenu.open = false;
      searchPanel.hidden = false;
      searchOpen.setAttribute('aria-expanded', 'true');
      psInput.focus();
    });
    searchPanel.querySelector('[data-search-close]').addEventListener('click', closeSearch);
    // A13.1: with the menu open, Search sits at the top of the panel; it closes the menu and opens the search panel.
    document.querySelectorAll('[data-menu-search]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        if (mobileMenu) mobileMenu.open = false;
        searchOpen.click();
      });
    });
  }

  const psOptions = () => Array.from(psResults ? psResults.querySelectorAll('[role="option"]') : []);
  const setActive = (index) => {
    const options = psOptions();
    options.forEach((o, i) => o.setAttribute('aria-selected', String(i === index)));
    psActive = index;
    if (index >= 0 && options[index]) {
      psInput.setAttribute('aria-activedescendant', options[index].id);
      options[index].scrollIntoView({ block: 'nearest' });
    } else {
      psInput.removeAttribute('aria-activedescendant');
    }
  };
  const runSearch = async () => {
    const q = psInput.value.trim();
    if (!q) {
      psResults.innerHTML = '';
      psInput.setAttribute('aria-expanded', 'false');
      setActive(-1);
      return;
    }
    if (psController) psController.abort();
    psController = new AbortController();
    const url = new URL(psResults.dataset.psUrl, window.location.origin);
    url.searchParams.set('q', q);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title');
    url.searchParams.set('section_id', 'predictive-search');
    try {
      const res = await fetch(url, { signal: psController.signal });
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('.shopify-section');
      psResults.innerHTML = section ? section.innerHTML : '';
      const hasOptions = psOptions().length > 0;
      psInput.setAttribute('aria-expanded', String(hasOptions));
      setActive(-1);
    } catch (e) {
      if (e.name !== 'AbortError') psResults.innerHTML = '';
    }
  };
  if (psInput && psResults) {
    psInput.addEventListener('input', () => {
      window.clearTimeout(psPending);
      psPending = window.setTimeout(runSearch, 250);
    });
    psInput.addEventListener('keydown', (event) => {
      const options = psOptions();
      if (!options.length) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(psActive < options.length - 1 ? psActive + 1 : 0);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(psActive > 0 ? psActive - 1 : options.length - 1);
      } else if (event.key === 'Enter' && psActive >= 0) {
        event.preventDefault();
        const link = options[psActive].querySelector('a');
        if (link) window.location.href = link.href;
      }
    });
  }

  const drawer = document.querySelector('[data-drawer]');
  let drawerTrigger = null;
  const qaDialog = document.getElementById('quick-add');
  let qaTrigger = null;

  const openDialog = (dialog, focusSelector) => {
    if (!dialog) return;
    if (!dialog.open) dialog.showModal();
    const target = dialog.querySelector(focusSelector);
    if (target) target.focus();
  };
  const updateHeaderCart = () => {
    const inner = drawer && drawer.querySelector('[data-drawer-inner]');
    const link = document.querySelector('[data-cart-open]');
    if (!inner || !link) return;
    link.setAttribute('aria-label', inner.dataset.cartLabel);
    const count = link.querySelector('[data-cart-count]');
    if (count) count.textContent = inner.dataset.cartCount ? '\u00a0' + inner.dataset.cartCount : '';
  };
  const replaceDrawer = (html) => {
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-drawer-inner]');
    const current = drawer.querySelector('[data-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
    updateHeaderCart();
  };

  if (drawer) {
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        drawerTrigger = opener;
        openDialog(drawer, '#drawer-title');
      }
    });
    drawer.addEventListener('close', () => {
      if (drawerTrigger && document.contains(drawerTrigger)) drawerTrigger.focus();
      drawerTrigger = null;
    });
    drawer.addEventListener('click', async (event) => {
      if (event.target === drawer || event.target.closest('[data-dialog-close]')) {
        drawer.close();
        return;
      }
      const step = event.target.closest('[data-qty]');
      const remove = event.target.closest('[data-remove]');
      if (!step && !remove) return;
      event.preventDefault();
      if (step && step.getAttribute('aria-disabled') === 'true') return;
      const line = event.target.closest('[data-line]');
      if (!line) return;
      const quantity = remove ? 0 : parseInt(step.dataset.qty, 10);
      const stepper = line.querySelector('.stepper');
      if (stepper) stepper.setAttribute('aria-busy', 'true');
      const lineIndex = parseInt(line.dataset.line, 10);
      try {
        const res = await fetch(routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok) throw new Error('change');
        replaceDrawer(data.sections && data.sections['cart-drawer']);
        const inner = drawer.querySelector('[data-drawer-inner]');
        announce(inner && inner.dataset.tUpdated);
        const sameLine = drawer.querySelector('[data-line="' + lineIndex + '"] .stepper-btn');
        const title = drawer.querySelector('#drawer-title');
        if (sameLine) sameLine.focus();
        else if (title) title.focus();
      } catch (e) {
        if (stepper) stepper.removeAttribute('aria-busy');
        const inner = drawer.querySelector('[data-drawer-inner]');
        announce(inner && inner.dataset.tFailed);
      }
    });
  }

  if (qaDialog) {
    qaDialog.addEventListener('close', () => {
      if (qaTrigger && document.contains(qaTrigger)) qaTrigger.focus();
      qaTrigger = null;
    });
    qaDialog.addEventListener('click', (event) => {
      if (event.target === qaDialog || event.target.closest('[data-dialog-close]')) qaDialog.close();
    });
    document.addEventListener('click', async (event) => {
      const trigger = event.target.closest('[data-quick-add]');
      if (!trigger) return;
      event.preventDefault();
      qaTrigger = trigger;
      try {
        const url = new URL(trigger.dataset.quickAdd, window.location.origin);
        url.searchParams.set('section_id', 'quick-add');
        const res = await fetch(url);
        if (!res.ok) throw new Error('quick add');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.qa-inner');
        const body = qaDialog.querySelector('[data-quick-add-body]');
        body.innerHTML = '';
        if (inner) body.appendChild(inner);
        body.querySelectorAll('[data-product-form]').forEach((f) => initProductForm(f, false));
        openDialog(qaDialog, '#quick-add-title');
      } catch (e) {
        window.location.href = trigger.href;
      }
    });
    document.querySelectorAll('[data-quick-add]').forEach((a) => a.setAttribute('role', 'button'));
    document.addEventListener('keydown', (event) => {
      if (event.key === ' ' && event.target.matches && event.target.matches('[data-quick-add]')) {
        event.preventDefault();
        event.target.click();
      }
    });
  }

  function initProductForm(wrapper, isPage) {
    const form = wrapper.querySelector('form');
    const button = wrapper.querySelector('[data-add-button]');
    const message = wrapper.querySelector('[data-form-message]');
    const error = wrapper.querySelector('#pf-' + wrapper.dataset.uid + '-error');
    const hiddenId = wrapper.querySelector('[data-variant-id]');
    const scope = wrapper.closest('[data-pdp], .qa-inner') || document;
    const priceEl = scope.querySelector('[data-price]');
    const variantsEl = wrapper.querySelector('[data-variants]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const groups = Array.from(wrapper.querySelectorAll('[data-option-group]'));
    const t = wrapper.dataset;

    const currentVariant = () => {
      if (!groups.length) return variants[0] || null;
      const chosen = groups.map((g) => {
        const r = g.querySelector('input:checked');
        return r ? r.dataset.value : null;
      });
      if (chosen.some((v) => v === null)) return null;
      return variants.find((v) => v.options.every((o, i) => o === chosen[i])) || null;
    };
    const setButton = (variant) => {
      if (!button) return;
      const soldOut = variant && !variant.available;
      button.disabled = !!soldOut;
      if (soldOut) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
      button.textContent = soldOut ? t.tSoldOut : t.tAdd;
    };
    const handleChange = () => {
      const variant = currentVariant();
      if (error) error.hidden = true;
      if (message) message.hidden = true;
      if (hiddenId) hiddenId.value = variant ? variant.id : '';
      setButton(variant);
      if (variant) {
        if (priceEl) priceEl.textContent = variant.price;
        if (isPage) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
        announce(variant.price + (variant.available ? '' : ', ' + t.tSoldOut));
      }
    };
    wrapper.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) handleChange();
    });
    const initial = currentVariant();
    if (initial && groups.length) setButton(initial);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const variant = currentVariant();
      if (groups.length && !variant) {
        if (error) error.hidden = false;
        const first = groups[0].querySelector('input');
        if (first) first.focus();
        announce(t.tChoose);
        return;
      }
      if (!variant || !variant.available) return;
      const width = button.getBoundingClientRect().width;
      button.style.inlineSize = width + 'px';
      button.setAttribute('aria-busy', 'true');
      button.textContent = t.tAdding;
      const sizeGroup = groups[0] && groups[0].querySelector('input:checked');
      const sizeLabel = sizeGroup ? sizeGroup.dataset.value : '';
      try {
        const body = new FormData(form);
        body.set('id', variant.id);
        body.set('sections', 'cart-drawer');
        body.set('sections_url', window.location.pathname);
        const res = await fetch(routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
        const data = await res.json();
        if (!res.ok) {
          let text = t.tFailed;
          if (res.status === 422) {
            const cartRes = await fetch(routes.cart, { headers: { Accept: 'application/json' } });
            const cartData = cartRes.ok ? await cartRes.json() : { items: [] };
            if (cartData.items.some((item) => item.variant_id === variant.id)) text = t.tOver;
          }
          throw new Error(text);
        }
        replaceDrawer(data.sections && data.sections['cart-drawer']);
        announce(t.tAdded.replace('__SIZE__', sizeLabel));
        if (qaDialog && qaDialog.open) {
          qaTrigger = null;
          qaDialog.close();
        }
        drawerTrigger = document.querySelector('[data-cart-open]');
        openDialog(drawer, '#drawer-title');
      } catch (e) {
        if (message) {
          message.textContent = e.message && e.message !== 'Failed to fetch' ? e.message : t.tFailed;
          message.hidden = false;
        }
      } finally {
        button.removeAttribute('aria-busy');
        button.style.inlineSize = '';
        setButton(currentVariant());
      }
    });
  }
  document.querySelectorAll('[data-pdp] [data-product-form]').forEach((f) => initProductForm(f, true));

  document.querySelectorAll('[data-carousel]').forEach((region) => {
    const track = region.querySelector('[data-track]');
    const slides = track ? Array.from(track.children) : [];
    if (slides.length < 2) return;
    const prev = region.querySelector('[data-step="-1"]');
    const next = region.querySelector('[data-step="1"]');
    const pos = region.querySelector('[data-pos]');
    const liveEl = region.querySelector('[data-live]');
    const thumbs = Array.from(region.querySelectorAll('[data-go]'));
    const last = slides.length - 1;
    let current = 0;
    const indexNow = () => Math.max(0, Math.min(last, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    const render = (i, say) => {
      current = i;
      if (pos) pos.textContent = region.dataset.tPos.replace('__N__', i + 1);
      prev.setAttribute('aria-disabled', String(i === 0));
      next.setAttribute('aria-disabled', String(i === last));
      thumbs.forEach((t, k) => {
        if (k === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (say && liveEl) liveEl.textContent = region.dataset.tLive.replace('__N__', i + 1);
    };
    const go = (i) => {
      const target = Math.max(0, Math.min(last, i));
      const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: target * track.clientWidth, behavior: still ? 'auto' : 'smooth' });
      render(target, true);
    };
    prev.addEventListener('click', () => {
      if (current > 0) go(current - 1);
    });
    next.addEventListener('click', () => {
      if (current < last) go(current + 1);
    });
    thumbs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.go, 10))));
    region.addEventListener('keydown', (event) => {
      if (!region.contains(document.activeElement)) return;
      const keys = { ArrowLeft: () => go(current - 1), ArrowRight: () => go(current + 1), Home: () => go(0), End: () => go(last) };
      if (!keys[event.key]) return;
      event.preventDefault();
      keys[event.key]();
    });
    const settle = () => {
      const i = indexNow();
      if (i !== current) render(i, true);
    };
    if ('onscrollend' in window) track.addEventListener('scrollend', settle);
    else {
      let settleWait = 0;
      track.addEventListener('scroll', () => {
        window.clearTimeout(settleWait);
        settleWait = window.setTimeout(settle, 150);
      }, { passive: true });
    }
    window.addEventListener('resize', () => {
      track.scrollLeft = current * track.clientWidth;
    }, { passive: true });
    render(0, false);
  });

  const pairs = document.querySelector('[data-pairs][data-fallback]');
  if (pairs && pairs.dataset.recUrl && pairs.dataset.productId) {
    const list = pairs.querySelector('[data-pairs-list]');
    const fetchRows = async (intent) => {
      const url = new URL(pairs.dataset.recUrl, window.location.origin);
      url.searchParams.set('product_id', pairs.dataset.productId);
      url.searchParams.set('limit', '6');
      url.searchParams.set('intent', intent);
      url.searchParams.set('section_id', 'pairs-recommendations');
      const res = await fetch(url);
      if (!res.ok) return [];
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      return Array.from(doc.querySelectorAll('[data-pairs-found] > li')).slice(0, 3);
    };
    (async () => {
      try {
        let rows = await fetchRows('complementary');
        if (!rows.length) rows = await fetchRows('related');
        if (!rows.length) return;
        rows.forEach((row) => {
          const add = row.querySelector('[data-quick-add]');
          if (add) add.setAttribute('role', 'button');
          list.appendChild(row);
          const dup = document.querySelector(`[data-more] [data-handle="${CSS.escape(row.dataset.handle)}"]`);
          if (dup) dup.remove();
        });
        list.dataset.count = String(list.children.length);
        pairs.hidden = false;
        const more = document.querySelector('[data-more]');
        if (more && !more.querySelector('[data-handle]')) more.remove();
        const moreList = more && more.isConnected ? more.querySelector('.fill-row') : null;
        if (moreList) moreList.dataset.count = String(moreList.children.length);
      } catch (e) {
        pairs.hidden = true;
      }
    })();
  }

  const emailOk = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.closest('[data-product-form]')) return;
    const invalid = [];
    form.querySelectorAll('input[required], textarea[required], [data-error-blank]').forEach((field) => {
      const errorEl = document.getElementById(field.getAttribute('aria-describedby'));
      let bad = field.value.trim() === '';
      if (!bad && field.type === 'email') bad = !emailOk(field.value.trim());
      if (field.type === 'radio') return;
      if (bad) {
        field.setAttribute('aria-invalid', 'true');
        if (errorEl) {
          if (field.dataset.errorInvalid) errorEl.textContent = field.dataset.errorInvalid;
          errorEl.hidden = false;
        }
        invalid.push(field);
      } else {
        field.removeAttribute('aria-invalid');
        if (errorEl) errorEl.hidden = true;
      }
    });
    const summary = form.querySelector('.form-summary');
    if (invalid.length) {
      event.preventDefault();
      if (summary && invalid.length > 1) {
        summary.hidden = false;
        summary.focus();
      } else {
        if (summary) summary.hidden = true;
        invalid[0].focus();
      }
    }
  });
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const store = {
    get(k) {
      try {
        return window.sessionStorage.getItem(k);
      } catch (e) {
        return null;
      }
    },
    set(k, v) {
      try {
        window.sessionStorage.setItem(k, v);
      } catch (e) {
        return;
      }
    }
  };

  document.querySelectorAll('[data-knit]').forEach((box) => {
    if (reduceMotion || saveData || !('IntersectionObserver' in window)) return;
    const key = 'rvvn-knit-paused';
    let video = null;
    let control = null;
    let visible = false;
    let userPaused = store.get(key) === '1';
    const setControl = (paused) => {
      control.className = 'corner-control ' + (paused ? 'corner-control--play' : 'corner-control--pause');
      control.setAttribute('aria-label', paused ? box.dataset.tPlay : box.dataset.tPause);
    };
    const sync = () => {
      if (!video) return;
      if (visible && !userPaused) video.play().catch(() => {});
      else video.pause();
      setControl(userPaused);
    };
    const insert = () => {
      const wide = window.matchMedia('(min-width: 744px)').matches;
      const src = wide ? box.dataset.srcDesktop : box.dataset.srcMobile;
      if (!src) return;
      video = document.createElement('video');
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'none';
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('aria-hidden', 'true');
      video.src = src;
      // Fail safe (DEV-72): the poster stays visible until the video actually plays; a video that never loads or
      // plays can never cover the photograph with an empty frame.
      const still = box.querySelector('img');
      if (still && still.currentSrc) video.poster = still.currentSrc;
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      box.appendChild(video);
      control = document.createElement('button');
      control.type = 'button';
      box.appendChild(control);
      control.addEventListener('click', () => {
        userPaused = !userPaused;
        store.set(key, userPaused ? '1' : '0');
        sync();
      });
      setControl(userPaused);
      const playWatch = new IntersectionObserver((entries) => {
        visible = entries[0].intersectionRatio >= 0.25;
        sync();
      }, { threshold: [0, 0.25, 0.5, 1] });
      playWatch.observe(box);
    };
    const near = new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) {
        obs.disconnect();
        insert();
      }
    }, { rootMargin: '100% 0px' });
    near.observe(box);
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-heat-src]');
    if (!btn || !btn.dataset.heatSrc) return;
    const clip = document.createElement('video');
    clip.muted = true;
    clip.playsInline = true;
    clip.controls = true;
    clip.setAttribute('muted', '');
    clip.setAttribute('playsinline', '');
    clip.setAttribute('controls', '');
    clip.setAttribute('aria-describedby', btn.dataset.heatDesc);
    clip.setAttribute('tabindex', '-1');
    clip.src = btn.dataset.heatSrc;
    btn.replaceWith(clip);
    clip.focus();
    clip.play().catch(() => {});
  });

  const buy = document.querySelector('.pdp-buy');
  if (buy && 'ResizeObserver' in window) {
    const wideEnough = window.matchMedia('(min-width: 1024px)');
    const fits = () => {
      const ok = wideEnough.matches && buy.offsetHeight <= window.innerHeight - 96;
      buy.classList.toggle('is-sticky', ok);
    };
    new ResizeObserver(fits).observe(buy);
    window.addEventListener('resize', fits, { passive: true });
    buy.addEventListener('toggle', (event) => {
      const summary = event.target.querySelector && event.target.querySelector('summary');
      const hadFocus = summary && document.activeElement === summary;
      fits();
      if (hadFocus) {
        summary.focus({ preventScroll: true });
        summary.scrollIntoView({ block: 'nearest' });
      }
    }, true);
    fits();
  }
})();
